var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW3C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822",
    transform: "translate(-335 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(335 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "W3C__Icon",
    "data-name": "W3C\\xAE_Icon",
    transform: "translate(331.324 459.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w3c",
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M10.295,24.407l1.894,6.439,1.894-6.439h5.135v.64l-1.933,3.331a2.7,2.7,0,0,1,1.541,1.189,4.192,4.192,0,0,1-.242,4.441,2.4,2.4,0,0,1-1.979.979,2.372,2.372,0,0,1-1.593-.581,3.42,3.42,0,0,1-1.006-1.574l1.071-.444a2.439,2.439,0,0,0,.621.947,1.314,1.314,0,0,0,.908.346,1.09,1.09,0,0,0,.927-.614,2.755,2.755,0,0,0,.379-1.476,2.364,2.364,0,0,0-.4-1.476A1.743,1.743,0,0,0,16.03,29.5h-.522v-.627l1.828-3.161H15.129L15,25.926l-2.684,9.058h-.131l-1.959-6.556L8.271,34.984H8.14L5.006,24.406H6.377l1.894,6.439,1.28-4.336-.627-2.1H10.3Z",
    transform: "translate(0 -0.466)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w3c",
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M188.093,24.412a.953.953,0,0,0-.694.283,1.022,1.022,0,0,0-.3.716,1.01,1.01,0,0,0,1,1,1.02,1.02,0,0,0,.711-.3.96.96,0,0,0,.292-.7,1,1,0,0,0-.289-.7.979.979,0,0,0-.713-.3Zm.869,1.008a.83.83,0,0,1-.252.6.878.878,0,0,1-.622.256.853.853,0,0,1-.605-.258.864.864,0,0,1-.255-.608.889.889,0,0,1,.264-.622.835.835,0,0,1,.6-.247.864.864,0,0,1,.867.877Zm-.841-.594h-.427v1.133h.214v-.483h.211l.23.483h.239l-.253-.516a.3.3,0,0,0,.258-.305c0-.206-.155-.311-.471-.311Zm-.039.139c.2,0,.291.056.291.194s-.092.181-.286.181h-.181v-.375h.175Z",
    transform: "translate(-161.749 -0.472)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w3c",
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M143.81,23.881l.222,1.351-.786,1.5a2.89,2.89,0,0,0-.8-.991,1.258,1.258,0,0,0-1.128-.274,2.378,2.378,0,0,0-1.453,1.59,5.438,5.438,0,0,0-.342,1.88,4.275,4.275,0,0,0,.091,1.105,4.929,4.929,0,0,1-.473-2.177,5.462,5.462,0,0,1,.576-2.587,2.058,2.058,0,0,1,1.431-1.214,1.625,1.625,0,0,1,1.231.461,3.919,3.919,0,0,1,.661.895l.773-1.544Z",
    transform: "translate(-119.147)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w3c",
    id: "Path_8200",
    "data-name": "Path 8200",
    d: "M140.062,90.707a6.7,6.7,0,0,1-.564.861,3.454,3.454,0,0,1-1.083.872,2.018,2.018,0,0,1-1.2.205,2.362,2.362,0,0,1-1.065-.433,4.151,4.151,0,0,1-.77-.764c-.223-.314-.57-.94-.57-.94s.193.628.315.895a5.782,5.782,0,0,0,.588,1.031,2.807,2.807,0,0,0,1.673,1.185,2.13,2.13,0,0,0,1.556-.319,4.284,4.284,0,0,0,.633-.546,4.782,4.782,0,0,0,.49-.645c.076-.119.2-.359.2-.359l-.2-1.042Z",
    transform: "translate(-115.302 -59.184)",
    fill: "#083f85"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3C);
export default __webpack_public_path__ + "static/media/w3c.6bd446fb.svg";
export { ForwardRef as ReactComponent };